import { jsx as i } from "react/jsx-runtime";
import { RocheUIPipelineLaneHeader as t } from "../pipeline-lane-header/roche-pipeline-lane-header.js";
import { RocheUIPipelineLaneRow as n } from "../pipeline-lane-row/roche-pipeline-lane-row.js";
const a = ({
  lanes: o,
  itemCountTextByLaneId: r
}) => /* @__PURE__ */ i(n, { laneCount: o.length, children: o.map((e) => /* @__PURE__ */ i(
  t,
  {
    lane: e,
    itemCountText: r[e.id] ?? "",
    hasShortLabel: !0
  },
  e.id
)) });
export {
  a as RocheUIPipelineChangesHeader
};
